import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { modalOptionsSelector, modalsSelector } from 'data/selectors/modals';
import { CloseIcon, ModalTitle, Footer } from '../baseModal/styles';

const SelectAllCompaniesModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { selectAll } = useSelector(modalOptionsSelector);

  const handleSelectAll = () => {
    selectAll();
    dispatch(toggleModal('select_all_companies', false));
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Warning
          <CloseIcon onClick={() => dispatch(toggleModal('select_all_companies', false))} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={() => dispatch(toggleModal('select_all_companies', false))}
    >
      <div>All companies in your profile have been selected.</div>
      <div>Are you sure, you want to make an operation on your entire company collection?</div>
      <Footer>
        <Button data-form="true" type="danger" size="large" onClick={handleSelectAll}>
          Yes, I&#39;m sure
        </Button>
        <Button size="large" type="default" onClick={() => dispatch(toggleModal('select_all_companies', false))}>
          Cancel
        </Button>
      </Footer>
    </Modal>
  );
};

export default SelectAllCompaniesModal;
